export const translationsConstants = {
    FETCH_TRANSLATIONS_REQUEST: 'FETCH_TRANSLATIONS_REQUEST',
    FETCH_TRANSLATIONS_SUCCESS: 'FETCH_TRANSLATIONS_SUCCESS',
    FETCH_TRANSLATIONS_FAILURE: 'FETCH_TRANSLATIONS_FAILURE'
};
